import { formatDate } from 'react/utils/utils';

export const formatDateTime = (date) => {
  if (!date) return '--:--:--';

  return formatDate(date);
};
